module.exports = __webpack_public_path__ + "static/media/scanner.887469b3.png";